import React from "react";
// import "./Footer.css";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const Footer = () => {
  return (
    <div className="relative bg-[#b28585] px-3 pt-7 pb-2 text-[whitesmoke]">
      <div className="grid grid-cols-1 gap-x-2 gap-y-10 md:grid-cols-2 lg:grid-cols-4 px-4 mb-10">
        <div>
          <div className="border-b border-[#b5b5b5] border-b-1 mb-2 py-2 font-light w-1/2">
            Main Menu
          </div>
          <div className="my-3 mt-4 text-sm">Clothing</div>
          <div className="my-3 text-sm">Wedding Collection</div>
          <div className="my-3 text-sm">Accessories</div>
        </div>

        <div>
          <div className="footer-heading border-b border-[#b5b5b5] border-b-1 mb-2 py-2 font-light w-1/2">
            Footer Menu
          </div>
          <div className="my-3 text-sm mt-4">About Us</div>
          <div className="my-3 text-sm">Contact Us</div>
          <div className="my-3 text-sm">Payments & Shipping</div>
          <div className="my-3 text-sm">Returns & Exchange</div>
          <div className="my-3 text-sm">Privacy Policy</div>
          <div className="my-3 text-sm">Terms Of Service</div>
        </div>

        <div>
          <div className="border-b border-[#b5b5b5] border-b-1 mb-2 py-2 font-light w-1/2">
            Reach Out To Us
          </div>
          <div className="my-3 text-sm mt-4">
            <span>Email :</span> contact@aashapurasafahouse.com
          </div>
          <div className="my-3 text-sm">
            <span>Whatsapp Us :</span> +91 9784254025
          </div>
          <div className="my-3 text-sm">Monday - Saturday</div>
          <div className="my-3 text-sm">11 am - 6 pm</div>
          <div className="my-3 text-sm">
            {/* <a href="https: facebook" className="mr-4">
              <FacebookIcon />
            </a> */}
            <a
              href="https://www.instagram.com/aashapura_safa_barmer/"
              target="_blank"
              className="mr-4"
            >
              <InstagramIcon />
            </a>
            <a
              href="https://www.youtube.com/@aashapura_safa_barmer"
              target="_blank"
              className="mr-4"
            >
              <YouTubeIcon />
            </a>
            <a
              href="https://wa.me/919784254025"
              target="_blank"
              className="mr-4"
            >
              <WhatsAppIcon />
            </a>
          </div>
        </div>

        <div className="container">
          <div className="border-b border-[#b5b5b5] border-b-1 mb-2 py-2 font-light w-1/2">
            Newsletter
          </div>
          <div className="my-3 text-sm mt-4">
            Get notified for New Collections and <br /> Offers before the rest
          </div>
          <div className="my-3 text-sm">
            <input
              className="border pl-2 py-3.5 text-xs border-white bg-[#b28585] text-white focus:outline-none placeholder-white w-11/12  "
              type="email"
              placeholder="Enter your email address"
            />
          </div>
          <button className="my-3 text-sm px-7 py-2.5 bg-[#5E3E3E] hover:bg-[#604c4c] hover:border-[#5e3e3e]">
            SUBSCRIBE
          </button>
        </div>
      </div>

      <div className="pt-11 text-center text-sm mx-auto ">
        <div>
          <div>&copy; 2024 Aashapura Safa House</div>
          <div>{/* Developed By : <a href="#">SolKode Media</a> */}</div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
